import React, { useEffect } from 'react'

import { useReward } from 'react-rewards';


const Rewords = (props) => {
  const { reward, isAnimating } = useReward('rewardId', 'confetti', { elementCount: 250, lifetime: 5000, spread: 200 });
  useEffect(() => {
    if (props.isCorrect) {
      setTimeout(() => {
        reward();
      }, 1000);
    }
  }, [props.isCorrect])
  return (
    <>
      <span id="rewardId" />
    </>
  )
}

export default Rewords
